module.exports = __webpack_public_path__ + "img/ic_logout.9a4c7350.png";